<section class="flex flex-column consult__section">
  <div class="inline-flex align-items-center justify-content-between consult__section-subheading-group">
    <h2 class="consult__section-subheading">
      <label for="odontogram_{{turn}}" class="field__label no-margin">{{screen.labels.odontogram.heading}}</label>
    </h2>
    <span class="consult__section-help" [style.width.%]="60">{{screen.labels.odontogram.help}}</span>
  </div>

  <div class="odontogram-view__wrapper">
    <div id="odontogram-view" class="odontogram-view">
      <div class="col-12 px-0 inline-flex flex-wrap justify-content-between align-items-center odontogram__wrapper">
        <div class="odontogram__row" *ngFor="let row of value">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" class="odontogram__teeth" [ngClass]="{
            'odontogram__teeth--square': row.type === 'V',
            'odontogram__teeth--circle': row.type === 'L'
          }" [class.odontogram__teeth--square]="row.type === 'V'" [class.odontogram__teeth--circle]="row.type === 'L'"
            *ngFor="let teeth of row.children" pDroppable="teethDD" (onDrop)="handleDropTeeth(teeth)">
            <path
              class="odontogram__section odontogram__section--{{section.side}} odontogram__section--{{teeth.symbology ? 'white' : section.color}}"
              *ngFor="let section of teeth.children" [attr.d]="buildPathBySide(row.type!, section.side!)"
              (click)="handleSectionClick($event, section)" />
            <path class="odontogram__symbol-path odontogram__symbol-path--{{teeth.symbologyColor}}"
              [attr.d]="teeth.symbologyIcon" *ngIf="teeth.symbology"></path>
          </svg>
        </div>
      </div>

      <div class="col-12 px-0 inline-flex flex-wrap" *ngIf="symbology">
        <div class="col-4 inline-flex align-items-center" *ngFor="let symbol of symbology" pDraggable="teethDD"
          (onDragStart)="selectedSymbology = symbol">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" class="odontogram__symbol">
            <path class="odontogram__symbol-path odontogram__symbol-path--{{symbol.color}}" [attr.d]="symbol.icon">
            </path>
          </svg>
          <span class="odontogram__symbol-text">{{symbol.description}}</span>
        </div>
      </div>
    </div>
  </div>
</section>